import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Skeleton } from '@material-ui/lab';
import IMG from '../img';

const ImageSetContainer = styled.div`
`;

const Preview = styled(IMG)`
  width: 100%;
  height: 300px;
  object-fit: contain;
`;

const PreviewUnprepared = styled(Skeleton)`
  width: 100%;
  height: 300px;
`;

const CandidateContainer = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
  text-align: left;
`;

const Candidate = styled(IMG)`
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;
  margin: 10px 10px 0px 10px;
  &:hover{
    opacity: 0.6;
  }
`;

const CandidateUnprepared = styled(Skeleton)`
  width: 100px;
  height: 100px;
  display: inline-block;
  margin: 10px 10px 0px 10px;
`;

export default ({ images, isPrepared }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    setSelectedImage(_.get(images, [0], null));
  }, [images]);
  return (
    <ImageSetContainer>
      {isPrepared ? <Preview src={selectedImage} /> : <PreviewUnprepared animation="wave" />}
      <CandidateContainer>
        {
          (isPrepared ? images : [Math.random(), Math.random(), Math.random()])
            .map((image) => (
              isPrepared ? (
                <Candidate
                  key={image}
                  src={image}
                  onClick={() => setSelectedImage(image)}
                />
              ) : (
                <CandidateUnprepared key={image} animation="wave" />
              )
            ))
        }
      </CandidateContainer>
    </ImageSetContainer>
  );
};
